import React from 'react'

const Orders = () => {
  return (
    <div>
      <h1> ORDERS TAB</h1>
      
    </div>
  )
}

export default Orders
